import qs from "qs";
import axios from "axios";

export class RuejaiClubSalePackagesClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/packages`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/sales${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }
  // PROBLEM: now we hard code for prefill with production package data
  // TODO: fix hardcode
  async getProductionPackage(id) {
    const url = `https://baanruejai-api.scasset.com/api/admin/subscriptions/recommend_packages/${id}`;

    const response = axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/ruejai-club/ruejaiClubSalePackages.js